import { Badge } from '@/components/ui/badge';

type TenantStatus = 'onboarding' | 'active' | 'paused' | 'cancelled';

const tenantMap: Record<TenantStatus, { variant: 'info' | 'success' | 'warning' | 'destructive'; label: string }> = {
  onboarding: { variant: 'info', label: 'Onboarding' },
  active: { variant: 'success', label: 'Activo' },
  paused: { variant: 'warning', label: 'Pausado' },
  cancelled: { variant: 'destructive', label: 'Cancelado' },
};

export function TenantStatusBadge({ status }: { status: TenantStatus }) {
  const { variant, label } = tenantMap[status];
  return <Badge variant={variant}>{label}</Badge>;
}
